const META_PIXEL_ID = '752156400787073';

class MetaPixelService {
    constructor() {
        this.isLoaded = false;
        this.isInitialized = false;
    }

    init() {
        if (this.isInitialized) return;

        const consent = this.getConsentStatus();

        if (!consent.marketing) {
            return;
        }

        this.loadFacebookPixel();

        if (typeof fbq !== 'undefined') {
            fbq('init', META_PIXEL_ID);
            fbq('track', 'PageView');
            this.isInitialized = true;
        }
    }

    loadFacebookPixel() {
        if (this.isLoaded) return;

        (function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = '2.0';
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

        this.isLoaded = true;
    }

    track(event, parameters = {}) {
        if (!this.isInitialized) {
            return;
        }

        if (typeof fbq !== 'undefined') {
            fbq('track', event, parameters);
        }
    }

    trackCustom(eventName, parameters = {}) {
        if (!this.isInitialized) return;

        if (typeof fbq !== 'undefined') {
            fbq('trackCustom', eventName, parameters);
        }
    }

    updateConsent(consent) {
        if (consent.marketing && !this.isInitialized) {
            this.init();
        } else if (!consent.marketing && this.isInitialized) {
            this.deactivate();
        }
    }

    deactivate() {
        if (typeof fbq !== 'undefined') {
            fbq('consent', 'revoke');
        }

        this.isInitialized = false;
    }

    getConsentStatus() {
        try {
            const saved = localStorage.getItem('cookie-consent');
            if (saved) {
                const consent = JSON.parse(saved);
                return consent.preferences || { essential: true, marketing: false };
            }
        } catch (error) {
            /* ignore */
        }

        return { essential: true, marketing: false };
    }

    isActive() {
        return this.isInitialized;
    }

    getPixelId() {
        return META_PIXEL_ID;
    }
}

const metaPixelService = new MetaPixelService();

export default metaPixelService;

export const initMetaPixel = () => metaPixelService.init();
export const trackEvent = (event, params) => metaPixelService.track(event, params);
export const trackCustomEvent = (eventName, params) =>
    metaPixelService.trackCustom(eventName, params);
export const updateMetaPixelConsent = (consent) => metaPixelService.updateConsent(consent);
